
import './App.scss';
import React, { useContext } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";


import Menu from './components/menu/menu';
import General from './components/general/general';
import Footer from './components/footer/footer';
import Advice from './components/advice/advice';
import Team from './components/team/team';
import Offers from './components/offers/offers';
import Form from './components/form/form';
import { ModalContext } from './services/modalContext';
import Politics from './components/politics/politics';

function App() {

    const { contextModal, setContextModal } = useContext(ModalContext);

    return (
        <div className="App">
            <Router>
                <Menu />

                <div className={`modal modal${contextModal.isShow ? 'Open' : ''}`}>
                    <svg viewBox="0 0 512 512" className='close' onClick={() => setContextModal(false)}>
                        <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z" />
                    </svg>

                    <Form handlerSubmit={() => setContextModal(false)} status={contextModal.status} />
                </div>

                <Switch>
                    <Route path="/advice">
                        <Advice />
                    </Route>

                    <Route path="/team">
                        <Team />
                    </Route>

                    <Route path="/offers/:id">
                        <Offers />
                    </Route>

                    <Route path="/offers">
                        <Offers />
                    </Route>

                    <Route path="/politics">
                        <Politics />
                    </Route>

                    <Route path="/:id">
                        <General />
                    </Route>

                    <Route path="/">
                        <General />
                    </Route>
                </Switch>

                <Footer />

            </Router>
        </div>
    );
}

export default App;
